module.exports = __webpack_public_path__ + "static/media/horizontal-complete-logo-magenta.0b9f4cb3.png";